// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fj-a";
export var fulfillmentFormRail = "_fj-9";
export var headerTitleRow = "_fj-c";
export var orderDetailsWrapper = "_fj-7";
export var orderLinkTrigger = "_fj-2";
export var paymentInformationGrid = "_fj-h";
export var paymentSummaryColumn = "_fj-i";
export var shipmentContainer = "_fj-b";
export var shipmentDetailsMainPane = "_fj-8";
export var shipmentNavigationCard = "_fj-5";
export var shipmentNavigationRail = "_fj-3";
export var shipmentNavigationRailHeader = "_fj-4";
export var shipmentSummaryFact = "_fj-e";
export var shipmentSummaryGrid = "_fj-d";
export var shipmentSummaryMetadataRow = "_fj-f";
export var shipmentSummaryTags = "_fj-g";
export var shipmentWorkspace = "_fj-0";
export var shipmentWorkspaceContent = "_fj-6";
export var shipmentWorkspaceHeader = "_fj-1";